import React, { useEffect, useState } from 'react';
import { useAuth } from "../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { 
  FiLogOut, 
  FiShoppingBag, 
  FiCalendar, 
  FiPrinter, 
  FiEdit2, 
  FiUser, 
  FiMenu, 
  FiX,
  FiChevronLeft,
  FiChevronRight,
  FiGift,
  FiClock,
  FiAlertTriangle,
  FiUserX,
  FiAlertCircle
} from 'react-icons/fi';
import { BIRTHDAY_EXTENSION_EMAILS, tieneAcceso } from '../constants/Accesos';


const NavBar = ({ children }) => {
    const { logout, user, getTiendas } = useAuth();
    const [mail, setMail] = useState('');
    const [acceso, setAcceso] = useState('');
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    // Navigation handlers
    const navigationHandlers = {
        pedidos: () => navigate(acceso !== 'TODO' ? "/pedidoecommerce" : "/pedidosgeneral"),
        programados: () => navigate(acceso !== 'TODO' ? "/pedidosprogramados" : "/pedidosprogramadosgeneral"),
        reimprimir: () => navigate(acceso !== 'TODO' ? "/reemprimir" : "/reimprimirtiendas"),
        dedicatoria: () => navigate(acceso !== 'TODO' ? "/dedicatoria" : "/dedicatoriatienda"),
        reclamos: () => navigate("/reclamos"),
        incidencias: () => navigate("/incidencias"),
        birthday: () => navigate(acceso !== 'TODO' ? "/validar-cumpleanos" : "/validar-cumpleanos-todos"),
        birthdayExtension: () => navigate("/validar-cumpleanos/extensiones"),
        cesePersonal: () => {
  if (acceso === 'TODO') {
    navigate('/cese-personal');
  }
},
        //cesePersonal: () => navigate(acceso !== 'TODO' ? "/cese-personal" : "/cese-personal"),
        ceseLiberacion: () => navigate("/cese-personal/liberacion"),
        logout: async () => {
            try {
                await logout();
                navigate("/login");
            } catch (error) {
                console.error(error.message);
            }
        }
    };

    // Check if a route is active
    const isActive = (path) => {
        return location.pathname === path;
    };

    // Navigation items
    const navItems = [
        {
            name: 'Pedidos Ecommerce',
            handler: navigationHandlers.pedidos,
            icon: <FiShoppingBag className="text-lg" />,
            path: acceso !== 'TODO' ? "/pedidoecommerce" : "/pedidosgeneral"
        },
        {
            name: 'Pedidos Programados',
            handler: navigationHandlers.programados,
            icon: <FiCalendar className="text-lg" />,
            path: acceso !== 'TODO' ? "/pedidosprogramados" : "/pedidosprogramadosgeneral"
        },
        {
            name: 'Reimpresión',
            handler: navigationHandlers.reimprimir,
            icon: <FiPrinter className="text-lg" />,
            path: acceso !== 'TODO' ? "/reimprimir" : "/reprimirotrastiendas"
        },
        {
            name: 'Dedicatoria',
            handler: navigationHandlers.dedicatoria,
            icon: <FiEdit2 className="text-lg" />,
            path: acceso !== 'TODO' ? "/dedicatoria" : "/dedicatoriatienda"
        },
        {
            name: 'Reclamos',
    handler: navigationHandlers.reclamos,
    icon: <FiAlertTriangle className="text-lg" />,
    path: "/reclamos",
    show: acceso === 'TODO'
},
        {
            name: 'Incidencias',
            handler: navigationHandlers.incidencias,
            icon: <FiAlertCircle className="text-lg" />,
            path: "/incidencias"
        },
        {
            name: 'Cese de Personal',
            handler: navigationHandlers.cesePersonal,
            icon: <FiUserX className="text-lg" />,
                       show: acceso === 'TODO'
        },
        {
            name: 'Liberación Cese',
            handler: navigationHandlers.ceseLiberacion,
            icon: <FiUserX className="text-lg" />,
            path: "/cese-personal/liberacion",
            show: acceso === 'TODO'
        },
        {
            name: 'Validar Cumpleaños',
            handler: navigationHandlers.birthday,
            icon: <FiGift className="text-lg" />,
            path:  acceso !== 'TODO' ? "/validar-cumpleanos" : "/validar-cumpleanos-todos"
        },
        {
            name: 'Extender Cumpleaños',
            handler: navigationHandlers.birthdayExtension,
            icon: <FiClock className="text-lg" />,
            path: "/validar-cumpleanos/extensiones",
            show: tieneAcceso(mail, BIRTHDAY_EXTENSION_EMAILS)
        }
    ];

    // Fetch user data
    useEffect(() => {
        if (user) {
            setMail(user.email);
        }
    }, [user]);

    // Fetch store data
    useEffect(() => {
        const fetchTiendas = async () => {
            if (mail) {
                try {
                    const tiendas = await getTiendas(mail);
                    if (tiendas && tiendas.length > 0) {
                        setAcceso(tiendas[0].tienda);
                    }
                } catch (error) {
                    console.error("Error al obtener las tiendas:", error);
                }
            }
        };
        fetchTiendas();
    }, [mail, getTiendas]);
    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    // Close mobile menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isMobileMenuOpen && !event.target.closest('.mobile-menu')) {
                setIsMobileMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMobileMenuOpen]);

    return (
        <>
            {/* Mobile menu button */}
            <button 
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="fixed top-4 left-4 z-50 p-2 rounded-md bg-white shadow-md text-gray-600 md:hidden"
                aria-label="Toggle menu"
            >
                {isMobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
            </button>

            {/* Sidebar */}
            <div className={`fixed inset-y-0 left-0 z-40 flex flex-col bg-white shadow-lg transition-all duration-300 ease-in-out transform ${isCollapsed ? 'w-16' : 'w-64'} ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}`}>
                {/* Logo and collapse button */}
                <div className="flex items-center justify-between p-4 border-b border-gray-200">
                    {!isCollapsed && (
                        <h1 className="text-xl font-bold text-gray-800 whitespace-nowrap">Sistema de Pedidos</h1>
                    )}
                    <button
                        onClick={toggleSidebar}
                        className="p-2 rounded-full hover:bg-gray-100 text-gray-600"
                        aria-label={isCollapsed ? "Expandir menú" : "Contraer menú"}
                    >
                        {isCollapsed ? <FiChevronRight size={20} /> : <FiChevronLeft size={20} />}
                    </button>
                </div>

                {/* Navigation */}
                <nav className="flex-1 overflow-y-auto py-4">
                    <ul className="space-y-2 px-2">
                       {navItems
  .filter(item => item.show === undefined || item.show)  // Filtra los elementos
  .map((item, index) => (
    <li key={index}>
                                <button
                                    onClick={() => {
                                        item.handler();
                                        setIsMobileMenuOpen(false);
                                    }}
                                    className={`w-full flex items-center px-3 py-2.5 rounded-lg transition-colors duration-200 text-sm ${
                                        isActive(item.path)
                                            ? 'bg-blue-50 text-blue-700 font-medium'
                                            : 'text-gray-600 hover:bg-gray-50'
                                    }`}
                                    title={isCollapsed ? item.name : ''}
                                >
                                    <span className="flex items-center justify-center w-5">
                                        {React.cloneElement(item.icon, { className: 'h-4 w-4' })}
                                    </span>
                                    {!isCollapsed && (
                                        <span className="ml-3 text-sm">{item.name}</span>
                                    )}
                                </button>
                            </li>
                        ))}
                    </ul>
                </nav>

                {/* User info and logout */}
                <div className={`p-4 border-t border-gray-200 ${isCollapsed ? 'flex flex-col items-center' : ''}`}>
                    <div className={`flex items-center ${isCollapsed ? 'flex-col space-y-2' : 'space-x-3'}`}>
                        <div className="flex-shrink-0">
                            <div className="h-10 w-10 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center">
                                <FiUser className="h-5 w-5" />
                            </div>
                        </div>
                        {!isCollapsed && (
                            <div className="min-w-0 flex-1">
                                <p className="text-sm font-medium text-gray-900 truncate">
                                    {mail ? mail.split('@')[0] : 'Usuario'}
                                </p>
                                <p className="text-xs text-gray-500 truncate">
                                    {mail}
                                </p>
                            </div>
                        )}
                    </div>
                    <button
                        onClick={navigationHandlers.logout}
                        className={`mt-4 w-full flex items-center justify-center px-3 py-2 rounded-md text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors duration-200 ${
                            isCollapsed ? 'p-2' : 'justify-start'
                        }`}
                        title={isCollapsed ? 'Cerrar sesión' : ''}
                    >
                        <FiLogOut className={isCollapsed ? 'text-lg' : 'mr-2'} />
                        {!isCollapsed && 'Cerrar Sesión'}
                    </button>
                </div>
            </div>

            {/* Overlay for mobile */}
            {isMobileMenuOpen && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
                    onClick={() => setIsMobileMenuOpen(false)}
                />
            )}

            {/* Main content area with padding to account for sidebar */}
            <div className={`transition-all duration-300 ease-in-out ${isCollapsed ? 'md:pl-20' : 'md:pl-64'}`}>
                {/* This is where the page content will be rendered */}
                {React.Children.map(children, child => {
                    return React.cloneElement(child, {
                        className: `min-h-screen ${child.props.className || ''}`
                    });
                })}
            </div>
        </>
    );
};

export default NavBar;
